import React from 'react';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { InitialTestimonials, MoreTestimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { PackContents, MethodOverview } from './components/MethodOverview';
import { FAQ } from './components/FAQ';
import { CostComparison } from './components/CostComparison';
import { Guarantee, Footer } from './components/Footer';
import { FloatingNotification } from './components/FloatingNotification';
import { EmotionalClose } from './components/EmotionalClose';
const TransitionPhrase = () => <div className="max-w-3xl mx-auto px-6 py-12 md:py-20 text-center pt-[4px] pb-[4px]" data-id="element-0" data-mp="31c9ygdv1bhw7">
    <p className="text-xl md:text-3xl font-display italic text-brand-purpleDark/85 leading-relaxed font-[800]" data-id="element-1" data-mp="2wj8g1vvmd07v">
      La próxima sesión puede ser diferente.
    </p>
  </div>;
export function App() {
  return <div className="min-h-screen text-brand-text font-sans selection:bg-brand-purple/25 selection:text-brand-purpleDark bg-brand-surface" data-id="element-2" data-mp="23utby4e102bb">
      <UrgencyBanner data-id="element-3" data-mp="3mlj8gtrwtb2j" />
      <Hero data-id="element-4" data-mp="3ml17xky7saot" />
      <PackContents data-id="element-5" data-mp="3mkhm3t5g125i" />
      <InitialTestimonials data-id="element-6" data-mp="3mjztr7lwj82v" />
      <PainPoints data-id="element-7" data-mp="3mj6j3vjtnyfg" />
      <MethodOverview data-id="element-8" data-mp="3rcj846sey78q" />
      <MoreTestimonials data-id="element-9" data-mp="3rdapodp6e4g0" />
      <Guarantee data-id="element-10" data-mp="3rcsuzli5vya7" />
      <FAQ data-id="element-11" data-mp="3recc1ebn6dd1" />
      <CostComparison data-id="element-12" data-mp="5yj0slx59ec" />
      <TransitionPhrase data-id="element-13" data-mp="6htxpd5ixiv" />
      <EmotionalClose data-id="element-14" data-mp="4n6a3ahwrb3" />
      <Footer data-id="element-15" data-mp="82lr78302d1" />
      <FloatingNotification data-id="element-16" data-mp="7stte3h7l4p" />
    </div>;
}